import React from "react";
import { StyledSwipeableDrawer, StyledTypography, StyledButton } from "../../../../../../styled-mui";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MobileMenuWrapper from "../../MobileMenuWrapper";
import { Box, Stack } from "@mui/material";
import { CLICK } from "../../../../../../_foundation/constants/gtm";
import AsyncCall from "../../../../../../_foundation/gtm/async.service";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router";
import SmartLink from "../../../../../elements/smart-link/smart-link";
import { MODELSLIST_BIS } from "../../../../../../constants/routes";
// import MobileProductsLevel3Menu from "./MobileProductsLevel3Menu";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  levelOneCat: Record<string, any> | null;
  filteredLinksByCatL1: Record<string, any>[];
  menuLinksData?: Record<string, any>;
  pageParams?: Record<string, any> | null;
  categories?: Record<string, any>[];
  pathname?: string;
}

const linkCTAStyles: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  columnGap: "8px",
  fontSize: "15px",
  fontWeight: "500",
  lineHeight: "15px",
  textTransform: "none",
  color: "rgba(93, 137, 162, 1)",
  padding: "10px 0",
};

const MobileProductsLevel2Menu: React.FC<Props> = ({
  open,
  entireMenuCloseHandler,
  closeCurrentMenu,
  levelOneCat,
  filteredLinksByCatL1,
  pageParams = null,
  categories = [],
  pathname = "",
  menuLinksData,
}) => {
  const navigate = useNavigate();
  const levelTwoCategoryChildren = levelOneCat?.children || [];
  // const [selectedLevelTwoCat, setSelectedLevelTwoCat] = useState<Record<string, any> | null>(null);

  const closeProduitsLevel2Menu = () => {
    // setSelectedLevelTwoCat(null);
    closeCurrentMenu();
  };

  // const closeLevel3CategoryMenu = () => {
  //   setSelectedLevelTwoCat(null);
  // };

  const onCatItemClick = (catItem: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: "Produits",
      nav_level_2: levelOneCat?.name || "",
      nav_level_3: catItem?.name || "",
      nav_type: "link",
      btn_label: catItem?.name || "",
      click_destination: catItem?.seo?.href,
    });
    entireMenuCloseHandler();
    navigate(catItem?.identifier === "SCU1555698" ? MODELSLIST_BIS : catItem?.seo?.href);
  };

  const onAttachmentLinkClick = (item: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: "Produits",
      nav_level_2: levelOneCat?.name || "",
      nav_level_3: "",
      nav_type: "link",
      btn_label: item?.label || "",
      click_destination: item?.url || "",
    });
    entireMenuCloseHandler();
  };

  const isMagazineItem = (item: Record<string, any>) => {
    if (!item) return false;
    const label = (item?.label || "").toString().toLowerCase();
    const url = (item?.url || "").toString().toLowerCase();
    if (menuLinksData?.magazine && menuLinksData.magazine.label) {
      return label === menuLinksData.magazine.label.toString().toLowerCase();
    }
    return url.includes("magazine") || label.includes("magazine");
  };

  const shouldObfuscate = (item: Record<string, any>) => {
    if (!item) return false;
    const pageType = pageParams?.page?.type || "";
    if (typeof pageType === "string" && pageType.toLowerCase().includes("product")) return true;
    if (typeof pageType === "string" && pageType.toLowerCase().includes("category")) {
      if (isMagazineItem(item)) return true;
      const currentIdentifier = pageParams?.identifier || pageParams?.tokenValue || null;
      const currentParent = pageParams?.parentCategoryId || null;
      if (!currentParent) {
        const itemIdentifier = item?.identifier || item?.label || "";
        const isTopLevel = categories?.some((c) => c?.identifier === itemIdentifier);
        return !isTopLevel;
      }
      const itemIdentifier2 = item?.identifier || item?.label || "";
      const isSisterOrCurrent =
        itemIdentifier2 === currentIdentifier || categories?.some((c) => c?.identifier === itemIdentifier2);
      return !isSisterOrCurrent;
    }
    return false;
  };

  const onUniverseBtnClick = () => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: "Produits",
      nav_level_2: levelOneCat?.name || "",
      nav_level_3: "",
      nav_type: "cta",
      btn_label: "Découvrir l'univers",
      click_destination: levelOneCat?.seo?.href || "",
    });
    entireMenuCloseHandler();
    navigate(levelOneCat?.seo?.href);
  };

  return (
    <>
      <StyledSwipeableDrawer
        anchor="left"
        open={open}
        onClose={closeProduitsLevel2Menu}
        onOpen={() => null}
        className="child-drawer header-menu-level3 mobile-produits-level2-menu">
        <MobileMenuWrapper
          title={levelOneCat?.name || ""}
          isASubMenu
          entireMenuCloseHandler={entireMenuCloseHandler}
          closeCurrentMenu={closeProduitsLevel2Menu}>
          {levelTwoCategoryChildren.map((catItem: Record<string, any>, index: number) => (
            <Box
              key={catItem?.identifier}
              onClick={() => onCatItemClick(catItem)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "16px 12px",
                borderBottom: "1px solid rgba(0, 0, 0, 0.11)",
              }}>
              <Stack direction="row" justifyContent="space-between" width="100%">
                <StyledTypography
                  variant="body1"
                  component="p"
                  style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                  {catItem?.name || ""}
                </StyledTypography>
                <ChevronRightIcon sx={{ fontSize: "20px", color: "black" }} />
              </Stack>
            </Box>
          ))}
          <Box className="level-2-prod-cat-CTA-links" p="16px 12px">
            {filteredLinksByCatL1.map((linkItem: Record<string, any>, index: number) => (
              <span
                key={linkItem?.label + index}
                role="link"
                tabIndex={0}
                style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 0" }}
                onClick={() => {
                  onAttachmentLinkClick(linkItem);
                  if (linkItem?.target === "_blank") window.open(linkItem?.url, "_blank");
                  else if (linkItem?.url) navigate(linkItem?.url);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    onAttachmentLinkClick(linkItem);
                    if (linkItem?.target === "_blank") window.open(linkItem?.url, "_blank");
                    else if (linkItem?.url) navigate(linkItem?.url);
                  }
                }}>
                <span style={{ fontSize: 15, fontWeight: 500 }}>{linkItem?.label || ""}</span>
                <ArrowForwardIcon sx={{ width: 20 }} />
              </span>
            ))}
            <StyledButton
              variant="text"
              onClick={onUniverseBtnClick}
              sx={{ ...linkCTAStyles, color: "rgba(37, 36, 39, 1)", fontWeight: 700 }}>
              Découvrir l'univers
              <ArrowForwardIcon sx={{ width: 20 }} />
            </StyledButton>
          </Box>
        </MobileMenuWrapper>
      </StyledSwipeableDrawer>

      {/* NOTE: THIS LEVEL 3 MENU IS DISABLED FOR LH2-6648 TICKET REQUEST
      {/* LEVEL 3 CATEGORY PAGE, using "open" state to prevent unnecessary DOM size */}
      {/* {open && (
        <MobileProductsLevel3Menu
          levelOneCat={levelOneCat}
          levelTwoCat={selectedLevelTwoCat}
          open={selectedLevelTwoCat !== null}
          entireMenuCloseHandler={entireMenuCloseHandler}
          closeCurrentMenu={closeLevel3CategoryMenu}
          filteredLinksByCatL1={filteredLinksByCatL1}
        />
      )} */}
    </>
  );
};

export default MobileProductsLevel2Menu;
